import DatePicker from './DatePicker.component';

export * from './interfaces';

export default DatePicker;
